export default __webpack_public_path__ + "static/media/calender_back_icon_inactive.ea548f07.svg";